/**
 * Catch-all redirector — sends any unknown / legacy path to the external
 * Vercel marketing site ROOT. Never appends pathname, never preserves
 * query — the app subdomain does not attempt to deep-link into the
 * marketing site's information architecture.
 *
 * Mounted at <Route path="*"> as the LAST route in App.js.
 */
import React, { useEffect } from "react";
import { marketingUrl } from "@/lib/marketingUrl";

export default function MarketingRedirect() {
    const target = marketingUrl();

    useEffect(() => {
        try {
            window.location.replace(target);
        } catch {
            window.location.href = target;
        }
    }, [target]);

    return (
        <div
            data-testid="marketing-redirect"
            data-redirect-to={target}
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#0F2747",
                color: "#EEF3F8",
                fontFamily: "system-ui, -apple-system, sans-serif",
                textAlign: "center",
                padding: 40,
            }}
        >
            <meta httpEquiv="refresh" content={`0;url=${target}`} />
            <div>
                <div style={{ fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", opacity: 0.6, marginBottom: 10 }}>
                    Redirecting to thedreamforgecompany.com…
                </div>
                <div style={{ fontSize: 13, opacity: 0.9 }}>
                    <a href={target} style={{ color: "#DCEEFF" }}>{target}</a>
                </div>
            </div>
        </div>
    );
}
